var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-nav",
    {
      staticClass:
        "navbar-top navbar-expand navbar-dark bg-dark py-2 border-bottom sticky-top bg-success DSAD navbar-dark",
      attrs: { "container-classes": "container-fluid", type: "" },
    },
    [
      _c("div", { staticClass: "nav-menu" }, [
        _c("ul", { staticClass: "navbar-nav mdc-toolbar" }, [
          _c("li", { staticClass: "nav-item" }, [
            _c(
              "a",
              {
                staticClass:
                  "mdc-toolbar__icon d-flex align-items-center justify-content-between",
                attrs: { href: "#" },
              },
              [
                _c("div", { staticClass: "mdc-toolbar__per align-middle" }, [
                  _c("span", [_vm._v("75")]),
                  _c("div", { staticClass: "mdc-toolbar__slice" }, [
                    _c("div", { staticClass: "mdc-toolbar__bar" }),
                    _c("div", { staticClass: "mdc-toolbar__fill" }),
                  ]),
                ]),
              ]
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "navbar-brand mx-auto" }, [
        _c("a", { staticClass: "navbar-brand mr-0", attrs: { href: "#" } }, [
          _c("img", {
            attrs: { src: require("@/assets/img/brand/logo.svg"), alt: "" },
          }),
        ]),
      ]),
      _c("div", { staticClass: "nav-menu" }, [
        _c("div", { staticClass: "ml-auto" }, [
          _c("div", { staticClass: "d-flex" }, [
            _c("ul", { staticClass: "navbar-nav align-items-center" }, [
              _c(
                "li",
                { staticClass: "nav-item dropdown ml-2 ml-md-3" },
                [
                  _c(
                    "base-button",
                    {
                      staticClass: "borderRadius-25",
                      attrs: { type: "success" },
                      on: {
                        click: function ($event) {
                          return _vm.$emit("headerLoginClicked")
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "btn-min-sm" }, [
                        _vm._v("Sign in"),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }